import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { setup } from "@onmo/auth";
import type { KeycloakManagerOptions } from "@onmo/auth";

import App from "./App";
import "./index.css";
import { store } from "./store";
import { configureI18n } from "./configs/i18n";

configureI18n();

// Setup Auth - Keycloak for web
const authOptions: KeycloakManagerOptions = {
  provider: "keycloak",
  onLoad: "check-sso",
};
setup(store, authOptions);

const root = document.getElementById("root") as HTMLElement;
createRoot(root).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </StrictMode>,
);
